/* global GLightbox */
import { loadGLightbox } from "common/glightbox-loader";
import "./reviews-list-photos.scss";

export default () => {
  function initializeGLightbox() {
    GLightbox({
      selector: ".glightbox",
      touchNavigation: true,
      loop: false,
      autoplayVideos: false
    });
  }

  loadGLightbox(initializeGLightbox);
};
